// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/edit.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/session/activity.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LifelineEvent_block{
    display: flex;
    margin-left: 10px;
    gap: 12px;
    justify-content: space-between;
    align-items: flex-start;

    background: #FFFFFF;
    box-shadow: 0px 0px 18px rgba(202, 196, 208, 0.56);
    border-radius: 24px;
    padding: 8px 16px;
    align-self: flex-start;
    width: 90%;
}

.LifelineEvent_block_content{
    width: 100%;
}

.LifelineEvent_image{
    width: 30%;
    max-width: 100px;
    aspect-ratio: 0.7;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}

.LifelineEvent_header{
    margin-top: 18px;
    margin-bottom: 24px;
    display: flex;
    gap: 8px;
    justify-content: space-between;
    align-items: center;
}

.LifelineEvent_header_actions{
    display: flex;
    gap: 8px;
    align-items: center;
}

.LifelineEvent_header_left{

}

.LifelineEvent_header_date{
    font-style: italic;
    font-weight: 400;
    font-size: calc(8px * var(--fontScaler));
    line-height: 11px;

    color: #979797;
}

.LifelineEvent_header_date--session{
    color: #8E9ABB !important;
    font-style: normal;
    transition: color 0.2s;
}

.LifelineEvent_header_title{
    font-weight: 700;
    font-size: calc(16px * var(--fontScaler));
    line-height: 22px;

    color: #14AE5C;
}

.LifelineEvent_description{
    font-weight: 400;
    font-size: calc(14px * var(--fontScaler));
    line-height: 18px;
    margin-top: 8px;

    color: #666666;
}

.LifelineEvent_header_edit{
    width: 12px;
    height: 12px;
    min-width: 12px;
    min-height: 12px;
    flex-shrink: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    cursor: pointer;
    border: none;
    background-color: transparent;
}

.LifelineEvent_header_session{
    width: 24px;
    height: 24px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    cursor: pointer;
    border: none;
    background-color: transparent;
    opacity: 0.7;
    transition: opacity 0.2s;
}

.LifelineEvent_header_session:hover{
    opacity: 1;
}

.LifelineEvent_session_link{
    background: none;
    border: none;
    color: #8E9ABB;
    text-decoration: underline;
    cursor: pointer;
    font-size: calc(12px * var(--fontScaler));
    padding: 0;
    margin-top: 8px;
    transition: color 0.2s;
}

.LifelineEvent_session_link:hover{
    color: #6B7896;
}

.LifelineEvent_text{
    font-style: normal;
    font-weight: 400;
    font-size: calc(12px * var(--fontScaler));;
    line-height: 16px;

    color: #000000;
}

.LifelineEvent_block--negative{
    align-self: flex-end;
}

.LifelineEvent_block--negative .LifelineEvent_header_title{
    color: #E23424;
}

.LifelineEvent_block--negative .LifelineEvent_header_date{
    color: #E23424;
}

.LifelineEvent_block--negative .LifelineEvent_text{
    color: #E23424;
}

.LifelineEvent_block--negative .LifelineEvent_description{
    color: #E23424;
}

.LifelineEvent_block--low-importance{
    /*background: #F8F8F8;*/
}

.LifelineEvent_block--low-importance .LifelineEvent_header_title{
    color: #8E9ABB;
    font-weight: 400;
}

.LifelineEvent_block--low-importance .LifelineEvent_text{
    color: #8E9ABB;
}

.LifelineEvent_block--low-importance .LifelineEvent_description{
    color: #8E9ABB;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/lifeline/LifelineEvent.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,8BAA8B;IAC9B,uBAAuB;;IAEvB,mBAAmB;IACnB,kDAAkD;IAClD,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,QAAQ;IACR,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;;AAEA;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;IACxC,iBAAiB;;IAEjB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;;IAEjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,eAAe;;IAEf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yDAAoD;IACpD,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IACxB,eAAe;IACf,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yDAAgE;IAChE,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IACxB,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,yCAAyC;IACzC,UAAU;IACV,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;;IAEjB,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".LifelineEvent_block{\n    display: flex;\n    margin-left: 10px;\n    gap: 12px;\n    justify-content: space-between;\n    align-items: flex-start;\n\n    background: #FFFFFF;\n    box-shadow: 0px 0px 18px rgba(202, 196, 208, 0.56);\n    border-radius: 24px;\n    padding: 8px 16px;\n    align-self: flex-start;\n    width: 90%;\n}\n\n.LifelineEvent_block_content{\n    width: 100%;\n}\n\n.LifelineEvent_image{\n    width: 30%;\n    max-width: 100px;\n    aspect-ratio: 0.7;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n}\n\n.LifelineEvent_header{\n    margin-top: 18px;\n    margin-bottom: 24px;\n    display: flex;\n    gap: 8px;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.LifelineEvent_header_actions{\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.LifelineEvent_header_left{\n\n}\n\n.LifelineEvent_header_date{\n    font-style: italic;\n    font-weight: 400;\n    font-size: calc(8px * var(--fontScaler));\n    line-height: 11px;\n\n    color: #979797;\n}\n\n.LifelineEvent_header_date--session{\n    color: #8E9ABB !important;\n    font-style: normal;\n    transition: color 0.2s;\n}\n\n.LifelineEvent_header_title{\n    font-weight: 700;\n    font-size: calc(16px * var(--fontScaler));\n    line-height: 22px;\n\n    color: #14AE5C;\n}\n\n.LifelineEvent_description{\n    font-weight: 400;\n    font-size: calc(14px * var(--fontScaler));\n    line-height: 18px;\n    margin-top: 8px;\n\n    color: #666666;\n}\n\n.LifelineEvent_header_edit{\n    width: 12px;\n    height: 12px;\n    min-width: 12px;\n    min-height: 12px;\n    flex-shrink: 0;\n    background-image: url('../../../../assets/edit.svg');\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n    cursor: pointer;\n    border: none;\n    background-color: transparent;\n}\n\n.LifelineEvent_header_session{\n    width: 24px;\n    height: 24px;\n    background-image: url('../../../../assets/session/activity.svg');\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n    cursor: pointer;\n    border: none;\n    background-color: transparent;\n    opacity: 0.7;\n    transition: opacity 0.2s;\n}\n\n.LifelineEvent_header_session:hover{\n    opacity: 1;\n}\n\n.LifelineEvent_session_link{\n    background: none;\n    border: none;\n    color: #8E9ABB;\n    text-decoration: underline;\n    cursor: pointer;\n    font-size: calc(12px * var(--fontScaler));\n    padding: 0;\n    margin-top: 8px;\n    transition: color 0.2s;\n}\n\n.LifelineEvent_session_link:hover{\n    color: #6B7896;\n}\n\n.LifelineEvent_text{\n    font-style: normal;\n    font-weight: 400;\n    font-size: calc(12px * var(--fontScaler));;\n    line-height: 16px;\n\n    color: #000000;\n}\n\n.LifelineEvent_block--negative{\n    align-self: flex-end;\n}\n\n.LifelineEvent_block--negative .LifelineEvent_header_title{\n    color: #E23424;\n}\n\n.LifelineEvent_block--negative .LifelineEvent_header_date{\n    color: #E23424;\n}\n\n.LifelineEvent_block--negative .LifelineEvent_text{\n    color: #E23424;\n}\n\n.LifelineEvent_block--negative .LifelineEvent_description{\n    color: #E23424;\n}\n\n.LifelineEvent_block--low-importance{\n    /*background: #F8F8F8;*/\n}\n\n.LifelineEvent_block--low-importance .LifelineEvent_header_title{\n    color: #8E9ABB;\n    font-weight: 400;\n}\n\n.LifelineEvent_block--low-importance .LifelineEvent_text{\n    color: #8E9ABB;\n}\n\n.LifelineEvent_block--low-importance .LifelineEvent_description{\n    color: #8E9ABB;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
